// extracted by mini-css-extract-plugin
var _1 = "PdfViewerToolbarMenu-modulemenu__hjwSm";
var _2 = "PdfViewerToolbarMenu-moduleoption__T6VYd";
var _3 = "PdfViewerToolbarMenu-modulesection__JTdeK";
var _4 = "PdfViewerToolbarMenu-modulesectionTitle__FNSVP";
var _5 = "PdfViewerToolbarMenu-moduleselected__elsvd";
export { _1 as "menu", _2 as "option", _3 as "section", _4 as "sectionTitle", _5 as "selected" }
